<template>
  <div>
    <template v-if="operatorChangeDate">
      <div class="tc-gr__row">
        <div class="tc-gr__col--6">
          <span class="tc-title--xs">Önskat leveransdatum</span>
        </div>
        <div class="tc-gr__col--6">
          <span class="tc-body">{{ operatorChangeDate }} Leveransdatumet kommer att bekräftas av en tekniker</span>
        </div>
      </div>
    </template>
    <template v-else-if="isPastOrderDeadline">
      Planerad leverans mellan <strong>{{ deliveryStartDate }}</strong> och <strong>{{ deliveryEndDate }}</strong>.
    </template>
    <template v-else>
      Leverans mellan
      <strong>{{ deliveryStartDate }}</strong> och <strong>{{ deliveryEndDate }}</strong> om du beställer senast <strong>{{ orderDeadline }}</strong>.
    </template>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import isPast from 'date-fns/isPast'

export default defineComponent({
  name: 'DeliveryText',
  props: {
    deliveryStartDate: {
      type: String
    },
    deliveryEndDate: {
      type: String
    },
    orderDeadline: {
      type: String
    },
    operatorChangeDate: {
      type: String
    }
  },
  setup (props) {
    const isPastOrderDeadline = isPast(new Date(props.orderDeadline))

    return {
      isPastOrderDeadline
    }
  }
})
</script>
